<template>
  <hr>
  <footer class="r7e-footer-bar">
    <div class="r7e-footer-content">
      <span class="r7e-footer-text">{{ displayBuildInfo }}</span>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  buildInfo: {
    type: [String, Object],
    required: false,
    default: ''
  }
});

const displayBuildInfo = computed(() => {
  const value = props.buildInfo;
  if (typeof value === 'string') return value;
  if (value && typeof value === 'object' && 'value' in value) return value.value ?? '';
  return '';
});
</script>

<style scoped>
.r7e-footer-bar {
  /* position: fixed; */
  /* left: 0;
  right: 0;
  bottom: 0;
  z-index: 100; */
  background: var(--r7e-color-surface, #ffffff);
  border-top: 1px solid var(--r7e-color-border, #e5e7eb);
}

.r7e-footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.r7e-footer-text {
  color: var(--r7e-color-muted-text, #6b7280);
  font-size: 12px;
}
</style>


